export class GetCredits400Response {
    'error';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "error",
            "baseName": "error",
            "type": "string",
            "format": "tobedefined"
        }
    ];
    static getAttributeTypeMap() {
        return GetCredits400Response.attributeTypeMap;
    }
    constructor() {
    }
}
